module.exports = __webpack_public_path__ + "img/iphone.4ded4a34.png";